/**
 * Роли спейса и правила доступа. Единый источник для API (проверка) и web (что показывать).
 *
 * Принцип: роль задаётся рангом. Управлять (менять роль, удалять, приглашать на роль) можно только
 * теми, кто строго ниже тебя по рангу, и назначать только роли строго ниже своей. Владелец — один, его
 * роль не меняется этими действиями (передача владения — отдельная операция).
 */
export const SPACE_ROLES = ['owner', 'admin', 'moderator', 'member', 'viewer'];
export const ROLE_RANK = { owner: 4, admin: 3, moderator: 2, member: 1, viewer: 0 };
export const ROLE_LABEL_RU = {
    owner: 'Владелец',
    admin: 'Администратор',
    moderator: 'Модератор',
    member: 'Участник',
    viewer: 'Читатель',
};
/** Минимальная роль для действия. */
const MIN_ROLE = {
    'space.read': 'viewer',
    'space.update': 'admin',
    'space.delete': 'owner',
    'space.leave': 'viewer',
    'space.audit': 'admin',
    'space.billing': 'admin',
    'members.read': 'viewer',
    'members.invite': 'moderator',
    'members.manage': 'admin',
    'invitations.manage': 'moderator',
    'projects.create': 'member',
};
const atLeast = (role, min) => ROLE_RANK[role] >= ROLE_RANK[min];
export function can(role, action) {
    // Владелец не может «покинуть» спейс — только удалить или передать владение.
    if (action === 'space.leave')
        return role !== 'owner';
    return atLeast(role, MIN_ROLE[action]);
}
/** Какие роли актор может выдавать в приглашении. */
export function invitableRoles(actor) {
    if (!can(actor, 'members.invite'))
        return [];
    return SPACE_ROLES.filter((r) => r !== 'owner' && ROLE_RANK[r] < ROLE_RANK[actor]);
}
export function canInviteAs(actor, role) {
    return invitableRoles(actor).includes(role);
}
/** Может ли актор менять роль участника target на next. */
export function canChangeRole(actor, target, next) {
    if (!can(actor, 'members.manage'))
        return false;
    if (target === 'owner' || next === 'owner')
        return false;
    return ROLE_RANK[target] < ROLE_RANK[actor] && ROLE_RANK[next] < ROLE_RANK[actor];
}
/** Может ли актор удалить участника с ролью target из спейса. */
export function canRemoveMember(actor, target) {
    if (!can(actor, 'members.manage'))
        return false;
    return target !== 'owner' && ROLE_RANK[target] < ROLE_RANK[actor];
}
/**
 * Право видеть личные папки участников: admin и owner — всегда, member/viewer — никогда,
 * moderator — если владелец включил флаг.
 */
export function normalizeManagePrivate(role, requested) {
    if (role === 'owner' || role === 'admin')
        return true;
    if (role === 'moderator')
        return requested;
    return false;
}
//# sourceMappingURL=permissions.js.map